import { createContext } from 'react'

export const InOfferFlowContext = createContext<boolean>(false)
